export default {
  data() {
    return {
      buttonKey: 0,
      dataTableFooterProps: {
        "items-per-page-text": "Filas a mostrar",
        "items-per-page-options": [5, 10, 30, 50, 100, -1],
      },
    };
  },
  methods: {
    resetButtonClickState() {
      this.buttonKey++;
    }
  },
};